<script>
import SubHeader from "@/components/SubHeader";
export default {
  components: {
    SubHeader,
  },
  data: () => ({
    headerProps: {
      title: "Gerenciar Clientes",
      btns: [
        {
          text: "Novo",
          color: "primary",
          action: () => {},
          icon: "mdi-plus",
          path: "/cadastros/clientes/new",
          isRedirector: true,
        },
        {
          text: "Recarregar",
          color: "primary",
          action: () => {},
          icon: "mdi-update",
          path: "",
          isRedirector: false,
        },
      ],
    },
    dialog: false,
    search: "",
    headers: [
      { text: "Nome", value: "nome", sortable: false },
      // { text: "Tipo de Documento", value: "tipo_documento", sortable: false },
      { text: "Documento", value: "documento", sortable: false },
      { text: "Ações", value: "action", sortable: false, align: "right" },
    ],
    items: [],
    totalItems: 0,
    loading: false,
    searchDebounce: null,
    options: {
      page: 1,
      itemsPerPage: 10,
    },
  }),
  created() {
    this.initialize();
    this.headerProps.btns[1].action = () => this.initialize();
  },

  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },

  methods: {
    handleSearch: function (value) {
      this.search = value;
      clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        if (this.options.page !== 1) {
          this.options.page = 1;
          return;
        }

        this.initialize();
      }, 400);
    },
    initialize() {
      const { page, itemsPerPage } = this.options;
      const perPage = itemsPerPage > 0 ? itemsPerPage : 10;

      this.loading = true;
      this.$store.dispatch("activeLoader", true);
      return this.$http
        .get("/clientes", {
          params: {
            page,
            perPage,
            search: this.search,
          },
        })
        .then((r) => {
          this.items = r.data.data;
          this.totalItems = r.data.total;
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch("activeLoader", false);
        });
    },
    editar(id) {
      this.$router.push(`/cadastros/clientes/editar/${id}`);
    },
    deleteItem(id) {
      let c = confirm("Deseja apagar o registro?");
      if (c) {
        this.$store.dispatch("activeLoader", true);
        this.$http
          .post(`/clientes/delete/${id}`)
          .then((r) => {
            alert(r.data.success);
            return this.initialize();
          })
          .finally(() => {
            this.$store.dispatch("activeLoader", false);
          });
      }
    },
  },
};
</script>
